import UnderDevelopment from '../../components/common/UnderDevelopment'

const Alerts = () => {
  return <UnderDevelopment title="预警通知" />
}

export default Alerts
